import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Plug.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "PlugIcon";
const n = e;
export {
  n as Plug,
  e as PlugIcon
};
